import React from "react";
import PropTypes from "prop-types";
import Typography from "material-ui/Typography";
import classNames from "classnames";

import styles from "./Empty.scss";

const Empty = ({ message, icon }) => (
  <div className={styles.container}>
    {React.cloneElement(icon, {
      className: classNames({ mb3: true, [styles.icon]: true }),
      color: "secondary",
    })}
    <Typography type="title">{message}</Typography>
  </div>
);

Empty.propTypes = {
  message: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

export default Empty;



// WEBPACK FOOTER //
// ./src/pages/utils/empty/Empty.jsx